// ============================================================
// Mock data — pipeline de licitaciones (10 expedientes)
// ============================================================
export const MOCK_BIDS = [
  {
    id: 'sandetel-25-00158',
    code: 'EXPT 25-00158',
    lot: 'Lote 2',
    title: 'Servicios profesionales especializados para el desarrollo del programa de aceleración digital',
    entity: 'SANDETEL — Sociedad Andaluza para el Desarrollo de las Telecomunicaciones',
    entityShort: 'SANDETEL',
    region: 'Andalucía',
    cpv: '79410000-1 · Servicios de consultoría',
    status: 'analysis',
    budgetBase: 1_872_000,
    budgetVAT: 2_265_120,
    estimatedValue: 5_990_400,
    durationMonths: 12,
    extensions: '2 prórrogas × 12 meses',
    deadline: '2026-06-18',
    deadlineDays: 22,
    submittedAt: null,
    score: null,
    minScoreTechnical: 30,
    maxScoreTechnical: 50,
    techSubjective: 50,
    techAutomatic: 50,
    riskLevel: 'medium',
    estimatedCost: 1_640_500,
    margin: 12.4,
    teamLead: 'u1',
    team: ['u1','u2','u3','u5'],
    progress: 28,
    tags: ['Aceleración', 'Andalucía', 'Programa marco'],
    lastActivity: 'Hace 2 horas',
    documents: 14,
    flagship: true,
  },
  {
    id: 'min-igualdad-2026',
    code: 'EXPT 2026/0148',
    lot: 'Lote único',
    title: 'Diagnóstico y plan de acción de igualdad para PYMES industriales',
    entity: 'Ministerio de Igualdad — Instituto de las Mujeres',
    entityShort: 'Ministerio de Igualdad',
    region: 'Nacional',
    cpv: '85312300-2 · Servicios de orientación y asesoramiento',
    status: 'preparation',
    budgetBase: 420_000,
    budgetVAT: 508_200,
    estimatedValue: 504_000,
    durationMonths: 18,
    extensions: '1 prórroga × 6 meses',
    deadline: '2026-06-30',
    deadlineDays: 34,
    submittedAt: null,
    score: null,
    minScoreTechnical: 25,
    maxScoreTechnical: 50,
    techSubjective: 50,
    techAutomatic: 50,
    riskLevel: 'low',
    estimatedCost: 368_400,
    margin: 12.3,
    teamLead: 'u2',
    team: ['u2','u3'],
    progress: 64,
    tags: ['Igualdad','PYMES','Industria'],
    lastActivity: 'Hace 5 horas',
    documents: 22,
  },
  {
    id: 'ayto-madrid-2026',
    code: 'EXPT 2026/0512',
    lot: 'Lote 1',
    title: 'Acompañamiento a entidades del tercer sector en transformación digital',
    entity: 'Ayuntamiento de Madrid — Área de Innovación',
    entityShort: 'Ayto. de Madrid',
    region: 'Madrid',
    cpv: '72224000-1 · Servicios de consultoría en gestión de proyectos',
    status: 'preparation',
    budgetBase: 280_000,
    budgetVAT: 338_800,
    estimatedValue: 280_000,
    durationMonths: 12,
    extensions: 'Sin prórrogas',
    deadline: '2026-07-04',
    deadlineDays: 38,
    submittedAt: null,
    score: null,
    minScoreTechnical: 28,
    maxScoreTechnical: 55,
    techSubjective: 55,
    techAutomatic: 45,
    riskLevel: 'low',
    estimatedCost: 246_300,
    margin: 12.0,
    teamLead: 'u3',
    team: ['u3','u5'],
    progress: 41,
    tags: ['Tercer sector','Madrid','Digital'],
    lastActivity: 'Ayer',
    documents: 18,
  },
  {
    id: 'ich-cyl-2026',
    code: 'EXPT 2026/0072',
    lot: 'Lote único',
    title: 'Programa autonómico de innovación social y emprendimiento de impacto en Castilla y León',
    entity: 'ICE — Instituto para la Competitividad Empresarial',
    entityShort: 'ICE Castilla y León',
    region: 'Castilla y León',
    cpv: '79410000-1 · Servicios de consultoría',
    status: 'solvency',
    budgetBase: 620_000,
    budgetVAT: 750_200,
    estimatedValue: 620_000,
    durationMonths: 24,
    extensions: 'Sin prórrogas',
    deadline: '2026-06-10',
    deadlineDays: 14,
    submittedAt: null,
    score: null,
    minScoreTechnical: 30,
    maxScoreTechnical: 60,
    techSubjective: 60,
    techAutomatic: 40,
    riskLevel: 'medium',
    estimatedCost: 545_600,
    margin: 12.0,
    teamLead: 'u1',
    team: ['u1','u2','u4'],
    progress: 88,
    tags: ['Innovación social','CyL','Impact'],
    lastActivity: 'Hace 1 hora',
    documents: 31,
  },
  {
    id: 'ue-eismea-2026',
    code: 'EISMEA-2026-SMP-COSME',
    lot: 'Single lot',
    title: 'Boost-up support scheme for social impact entrepreneurs in Southern Europe',
    entity: 'European Innovation Council and SMEs Executive Agency',
    entityShort: 'EISMEA · UE',
    region: 'Unión Europea',
    cpv: '79420000-4 · Management-related services',
    status: 'submitted',
    budgetBase: 1_200_000,
    budgetVAT: 1_200_000,
    estimatedValue: 1_200_000,
    durationMonths: 30,
    extensions: 'No applicable',
    deadline: '2026-04-22',
    deadlineDays: -34,
    submittedAt: '2026-04-21',
    score: null,
    minScoreTechnical: 70,
    maxScoreTechnical: 100,
    techSubjective: 100,
    techAutomatic: 0,
    riskLevel: 'medium',
    estimatedCost: 1_058_000,
    margin: 11.8,
    teamLead: 'u1',
    team: ['u1','u2','u3','u4','u5'],
    progress: 100,
    tags: ['UE','Impacto social','Sur Europa'],
    lastActivity: 'Hace 5 semanas',
    documents: 47,
  },
  {
    id: 'junta-and-2025',
    code: 'EXPT 2025/2384',
    lot: 'Lote 3',
    title: 'Servicios de aceleración para empresas de economía social y solidaria de Andalucía',
    entity: 'Junta de Andalucía — Consejería de Empleo',
    entityShort: 'Junta de Andalucía',
    region: 'Andalucía',
    cpv: '79410000-1 · Servicios de consultoría',
    status: 'won',
    budgetBase: 890_000,
    budgetVAT: 1_076_900,
    estimatedValue: 890_000,
    durationMonths: 18,
    extensions: 'Sin prórrogas',
    deadline: '2026-03-15',
    deadlineDays: -72,
    submittedAt: '2026-03-12',
    score: 87,
    minScoreTechnical: 30,
    maxScoreTechnical: 55,
    techSubjective: 55,
    techAutomatic: 45,
    riskLevel: 'low',
    estimatedCost: 783_200,
    margin: 12.0,
    teamLead: 'u3',
    team: ['u1','u3','u5'],
    progress: 100,
    tags: ['Andalucía','ESS','Adjudicada'],
    lastActivity: 'Hace 2 meses',
    documents: 38,
  },
  {
    id: 'min-industria-2026',
    code: 'EXPT 2026/0094',
    lot: 'Lote 1',
    title: 'Programa de fortalecimiento de competencias digitales en clusters industriales',
    entity: 'Ministerio de Industria y Turismo',
    entityShort: 'Mº de Industria',
    region: 'Nacional',
    cpv: '80511000-9 · Servicios de formación a trabajadores',
    status: 'lost',
    budgetBase: 1_500_000,
    budgetVAT: 1_815_000,
    estimatedValue: 1_500_000,
    durationMonths: 24,
    extensions: '1 prórroga × 12 meses',
    deadline: '2026-02-28',
    deadlineDays: -88,
    submittedAt: '2026-02-26',
    score: 71,
    minScoreTechnical: 35,
    maxScoreTechnical: 50,
    techSubjective: 50,
    techAutomatic: 50,
    riskLevel: 'medium',
    estimatedCost: 1_320_000,
    margin: 12.0,
    teamLead: 'u2',
    team: ['u2','u4','u5'],
    progress: 100,
    tags: ['Formación','Industria','Clusters'],
    lastActivity: 'Hace 3 meses',
    documents: 41,
  },
  {
    id: 'red-it-2025',
    code: 'EXPT RED.es/2025/4421',
    lot: 'Lote único',
    title: 'Mentoría especializada a startups de la red Acelera PYME',
    entity: 'Red.es — Ministerio para la Transformación Digital',
    entityShort: 'Red.es',
    region: 'Nacional',
    cpv: '79410000-1 · Servicios de consultoría',
    status: 'lost',
    budgetBase: 740_000,
    budgetVAT: 895_400,
    estimatedValue: 740_000,
    durationMonths: 12,
    extensions: 'Sin prórrogas',
    deadline: '2026-01-30',
    deadlineDays: -117,
    submittedAt: '2026-01-28',
    score: 64,
    minScoreTechnical: 30,
    maxScoreTechnical: 50,
    techSubjective: 50,
    techAutomatic: 50,
    riskLevel: 'high',
    estimatedCost: 650_000,
    margin: 12.2,
    teamLead: 'u1',
    team: ['u1','u3'],
    progress: 100,
    tags: ['Acelera PYME','Mentoría','Red.es'],
    lastActivity: 'Hace 4 meses',
    documents: 36,
  },
  {
    id: 'aytobcn-2026',
    code: 'EXPT 2026/0331-BCN',
    lot: 'Lote 2',
    title: 'Asistencia técnica para la economía social y la innovación cívica',
    entity: 'Ajuntament de Barcelona — Promoció Econòmica',
    entityShort: 'Ajt. Barcelona',
    region: 'Cataluña',
    cpv: '79410000-1 · Servicios de consultoría',
    status: 'discarded',
    budgetBase: 320_000,
    budgetVAT: 387_200,
    estimatedValue: 320_000,
    durationMonths: 12,
    extensions: 'Sin prórrogas',
    deadline: '2026-05-04',
    deadlineDays: -23,
    submittedAt: null,
    score: null,
    minScoreTechnical: 35,
    maxScoreTechnical: 55,
    techSubjective: 55,
    techAutomatic: 45,
    riskLevel: 'high',
    estimatedCost: 318_400,
    margin: 0.5,
    teamLead: 'u4',
    team: ['u4'],
    progress: 12,
    tags: ['BCN','Economía social','Descartada'],
    lastActivity: 'Hace 3 semanas',
    documents: 4,
  },
  {
    id: 'feder-2025',
    code: 'EXPT FEDER/2025/0028',
    lot: 'Lote único',
    title: 'Asistencia técnica para la evaluación intermedia de programas FEDER 21-27',
    entity: 'Dirección General de Fondos Europeos',
    entityShort: 'DG Fondos UE',
    region: 'Nacional',
    cpv: '79419000-4 · Servicios de consultoría en evaluación',
    status: 'discarded',
    budgetBase: 980_000,
    budgetVAT: 1_185_800,
    estimatedValue: 980_000,
    durationMonths: 18,
    extensions: 'Sin prórrogas',
    deadline: '2025-12-15',
    deadlineDays: -163,
    submittedAt: null,
    score: null,
    minScoreTechnical: 30,
    maxScoreTechnical: 50,
    techSubjective: 50,
    techAutomatic: 50,
    riskLevel: 'medium',
    estimatedCost: 860_000,
    margin: 12.2,
    teamLead: 'u1',
    team: ['u1','u4'],
    progress: 0,
    tags: ['FEDER','Evaluación','UE'],
    lastActivity: 'Hace 6 meses',
    documents: 1,
  },
];
